import { AdsContext } from "@magalu/ecomm-components/contexts/AdsContext";
import { PlatformHooksProvider } from "@magalu/ravejs-platform-hooks";
import React from "react";
import DatadogInit from "./modules/DatadogInit";
import { ErrorBoundary } from "./modules/ErrorBoundary";
import WishlistProvider from "./modules/WishlistProvider";
export const render = ({ Component, pageProps }) => {
    return (<div id="rave-mixer hybrid" data-testid="rave-mixer hybrid">
      <PlatformHooksProvider config={pageProps === null || pageProps === void 0 ? void 0 : pageProps.manifest}>
        <DatadogInit />
        <ErrorBoundary>
          <WishlistProvider>
            <AdsContext data={pageProps.data}>
              <Component {...pageProps}/>
            </AdsContext>
          </WishlistProvider>
        </ErrorBoundary>
      </PlatformHooksProvider>
    </div>);
};
